import { buildSupportMailtoHref, SUPPORT_EMAIL } from "@/utils/supportEmail"

export function SupportContact() {
  return (
    <p className="text-center text-xs leading-5 text-coval-text-muted">
      Need help?{" "}
      <a
        href={buildSupportMailtoHref()}
        className="underline underline-offset-2 hover:text-coval-text"
      >
        {SUPPORT_EMAIL}
      </a>
    </p>
  )
}
